import { jsx as _jsx } from "react/jsx-runtime";
const SvgDota2Kill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0.529999L0.242948 2.78022L8.3566 10.1975L7.51978 10.9562C7.22285 11.225 7.20743 11.6706 7.48894 11.9542C7.77044 12.2378 8.23705 12.2525 8.53399 11.9837L9.75259 10.8825L12.1242 13.1144L12.1233 13.1238C12.1198 13.1644 12.1165 13.2022 12.1165 13.2432C12.1165 13.9135 12.6872 14.4586 13.3891 14.4586C14.0909 14.4586 14.6616 13.9135 14.6616 13.2432C14.6616 12.573 14.0909 12.0279 13.3891 12.0279C13.3428 12.0279 13.3004 12.0316 13.2541 12.0352L10.9326 9.81817L12.1782 8.6949C12.4752 8.42605 12.4905 7.98042 12.209 7.69684C11.9276 7.41326 11.461 7.39853 11.164 7.66737L10.2848 8.45919L2.50659 0.636802L0 0.529999Z",
		fill: "currentColor"
	})
});
export default SvgDota2Kill;
